module.exports = __webpack_public_path__ + "img/no-issues.3cd871a9.png";